import { render, staticRenderFns } from "./APIManagment.vue?vue&type=template&id=609c9bf6&"
import script from "./APIManagment.vue?vue&type=script&lang=js&"
export * from "./APIManagment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports